import { process, State } from '@progress/kendo-data-query';
import { GridDataStateChangeEvent, GridPagerSettings } from '@progress/kendo-react-grid';
import { GridSelectableSettings } from '@progress/kendo-react-grid/dist/npm/interfaces/GridSelectableSettings';
import { FC, useCallback, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import GridWrapper from 'src/components/GridWrapper';
interface ViewCheckbookPeriodWarningTableProps {
  glCodeWarningsColumnData: any[];
}

type WarningState = State;

const initialWarningDataState: WarningState = {
  skip: 0,
  take: 10,
};

const selectable: GridSelectableSettings = {
  enabled: false,
  drag: false,
  cell: false,
  mode: 'single',
};
const gridPagerSettings: GridPagerSettings = {
  buttonCount: 1,
  pageSizes: [10, 20, 30, 50],
};
const defaultProps = {
  tableTextId: 'GL Codes',
  sortable: false,
  resizable: true,
  showColumnMenu: false,
  selectable: selectable,
  pageable: gridPagerSettings,
} as const;
const ViewCheckbookPeriodWarningTable: FC<ViewCheckbookPeriodWarningTableProps> = ({
  glCodeWarningsColumnData,
}) => {
  const { t } = useTranslation();

  const [WarningDataState, setWarningDataState] = useState(initialWarningDataState);
  const onDataStateChange = useCallback((e: GridDataStateChangeEvent) => {
    setWarningDataState(e.dataState);
  }, []);
  const { data: processData, total } = useMemo(
    () =>
      process(
        glCodeWarningsColumnData?.map((el: any) => ({
          ...el,
          selected: false,
        })) || [],
        {
          ...WarningDataState,
          sort: [{ field: 'code', dir: 'asc' }],
        }
      ),
    [WarningDataState, glCodeWarningsColumnData]
  );
  return (
    <div className="mt-2">
      <GridWrapper
        columns={[
          {
            title: t('GL Code'),
            format: '',
            menu: false,
            filter: 'text',
            field: 'code',
          },
          {
            title: t('Description'),
            format: '',
            menu: false,
            field: 'description',
          },
        ]}
        dataSource={processData}
        DataItemKey="code"
        dataState={WarningDataState}
        onDataStateChange={onDataStateChange}
        total={total}
        style={{ maxHeight: '450px' }}
        {...defaultProps}
        noRecordText="No records to display"
      />
    </div>
  );
};

export default ViewCheckbookPeriodWarningTable;
